import noop from 'lodash/noop';
import { createContext, useContext, useMemo, useRef, useState } from 'react';
import { RFEdgeFloatingEdge } from '../edges';
import { SweepCanvasRfNode } from '../canvas-types/nodeTypesData';
export type ReorderSteps = {
  stepId: string;
  groupId: string;
};

interface ReorderStepsCtxProps {
  _isInitialized: boolean;
  reorderSteps?: ReorderSteps;
  setReorderSteps: (reorderSteps?: ReorderSteps) => void;
  previousNodes: React.MutableRefObject<SweepCanvasRfNode[] | undefined>;
  previousEdges: React.MutableRefObject<RFEdgeFloatingEdge[] | undefined>;
}

const ReorderStepsCtx = createContext<ReorderStepsCtxProps>({
  _isInitialized: false,
  setReorderSteps: noop,
  previousNodes: { current: undefined },
  previousEdges: { current: undefined },
});

export const ReorderStepsCtxProvider = ({ children }: { children: React.ReactNode }) => {
  const [reorderSteps, setReorderSteps] = useState<ReorderSteps>();
  const previousNodes = useRef<SweepCanvasRfNode[] | undefined>(undefined);
  const previousEdges = useRef<RFEdgeFloatingEdge[] | undefined>(undefined);

  return (
    <ReorderStepsCtx.Provider
      value={useMemo(
        () => ({
          reorderSteps,
          setReorderSteps,
          previousNodes,
          previousEdges,
          _isInitialized: true,
        }),
        [reorderSteps, setReorderSteps],
      )}
    >
      {children}
    </ReorderStepsCtx.Provider>
  );
};

export const useReorderStepsCtx = () => {
  const ctx = useContext(ReorderStepsCtx);
  if (!ctx._isInitialized) {
    throw new Error('ReorderStepsCtx is not initialized');
  }

  return useMemo(() => {
    return {
      ...ctx,
      isInReorderStepsMode: Boolean(ctx.reorderSteps),
    };
  }, [ctx]);
};
